export const cateData1 = [
    {
        "children": [
            {
                "itemId": 685,
                "label": "乔其10MM",
                "value": "乔其10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "乔其10MM"
                    },
                    {
                        "type": 8,
                        "content": "54"
                    },
                    {
                        "type": 9,
                        "content": "54"
                    }
                ]
            },
            {
                "itemId": 686,
                "label": "乔其12MM",
                "value": "乔其12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "乔其12MM"
                    },
                    {
                        "type": 8,
                        "content": "62"
                    },
                    {
                        "type": 9,
                        "content": "62"
                    }
                ]
            },
            {
                "itemId": 689,
                "label": "乔其8MM",
                "value": "乔其8MM",
                "option": [
                    {
                        "type": 0,
                        "content": "乔其8MM"
                    },
                    {
                        "type": 8,
                        "content": "43"
                    },
                    {
                        "type": 9,
                        "content": "43"
                    }
                ]
            },
            {
                "itemId": 690,
                "label": "人丝乔其10MM",
                "value": "人丝乔其10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "人丝乔其10MM"
                    }
                ]
            },
            {
                "itemId": 691,
                "label": "人丝乔其12MM",
                "value": "人丝乔其12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "人丝乔其12MM"
                    }
                ]
            },
            {
                "itemId": 692,
                "label": "人丝乔其16MM",
                "value": "人丝乔其16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "人丝乔其16MM"
                    }
                ]
            },
            {
                "itemId": 693,
                "label": "弹力乔其10MM",
                "value": "弹力乔其10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力乔其10MM"
                    }
                ]
            },
            {
                "itemId": 694,
                "label": "弹力乔其12MM",
                "value": "弹力乔其12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力乔其12MM"
                    }
                ]
            },
            {
                "itemId": 695,
                "label": "弹力乔其16MM",
                "value": "弹力乔其16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力乔其16MM"
                    }
                ]
            },
            {
                "itemId": 696,
                "label": "弹力乔其8MM",
                "value": "弹力乔其8MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力乔其8MM"
                    }
                ]
            },
            {
                "itemId": 697,
                "label": "顺纡乔其10MM",
                "value": "顺纡乔其10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其10MM"
                    }
                ]
            },
            {
                "itemId": 698,
                "label": "顺纡乔其12MM",
                "value": "顺纡乔其12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其12MM"
                    }
                ]
            },
            {
                "itemId": 699,
                "label": "顺纡乔其14MM",
                "value": "顺纡乔其14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其14MM"
                    }
                ]
            },
            {
                "itemId": 700,
                "label": "顺纡乔其15MM",
                "value": "顺纡乔其15MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其15MM"
                    }
                ]
            },
            {
                "itemId": 701,
                "label": "顺纡乔其16MM",
                "value": "顺纡乔其16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其16MM"
                    }
                ]
            },
            {
                "itemId": 702,
                "label": "顺纡乔其5.5MM",
                "value": "顺纡乔其5.5MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其5.5MM"
                    }
                ]
            },
            {
                "itemId": 703,
                "label": "顺纡乔其8MM",
                "value": "顺纡乔其8MM",
                "option": [
                    {
                        "type": 0,
                        "content": "顺纡乔其8MM"
                    }
                ]
            }
        ],
        "label": "乔其",
        "value": "乔其"
    },
    {
        "children": [
            {
                "itemId": 704,
                "label": "丝棉纺",
                "value": "丝棉纺",
                "option": [
                    {
                        "type": 0,
                        "content": "丝棉纺"
                    }
                ]
            },
            {
                "itemId": 705,
                "label": "人造棉",
                "value": "人造棉",
                "option": [
                    {
                        "type": 0,
                        "content": "人造棉"
                    }
                ]
            },
            {
                "itemId": 706,
                "label": "巴厘纱",
                "value": "巴厘纱",
                "option": [
                    {
                        "type": 0,
                        "content": "巴厘纱"
                    }
                ]
            },
            {
                "itemId": 707,
                "label": "绢纺",
                "value": "绢纺",
                "option": [
                    {
                        "type": 0,
                        "content": "绢纺"
                    }
                ]
            },
            {
                "itemId": 708,
                "label": "铜氨丝",
                "value": "铜氨丝",
                "option": [
                    {
                        "type": 0,
                        "content": "铜氨丝"
                    }
                ]
            },
            {
                "itemId": 9511,
                "label": "丝棉布",
                "value": "丝棉布",
                "option": [
                    {
                        "type": 0,
                        "content": "丝棉布"
                    }
                ]
            }
        ],
        "label": "其他",
        "value": "其他"
    },
    {
        "children": [
            {
                "itemId": 710,
                "label": "丝人丝双绉",
                "value": "丝人丝双绉",
                "option": [
                    {
                        "type": 0,
                        "content": "丝人丝双绉"
                    },
                    {
                        "type": 9,
                        "content": "55"
                    },
                    {
                        "type": 8,
                        "content": "55"
                    }
                ]
            },
            {
                "itemId": 715,
                "label": "双绉12MM",
                "value": "双绉12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "双绉12MM"
                    },
                    {
                        "type": 8,
                        "content": "63"
                    },
                    {
                        "type": 9,
                        "content": "63"
                    }
                ]
            },
            {
                "itemId": 716,
                "label": "双绉14MM",
                "value": "双绉14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "双绉14MM"
                    },
                    {
                        "type": 8,
                        "content": "71"
                    },
                    {
                        "type": 9,
                        "content": "71"
                    }
                ]
            },
            {
                "itemId": 717,
                "label": "双绉16MM",
                "value": "双绉16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "双绉16MM"
                    },
                    {
                        "type": 8,
                        "content": "80"
                    },
                    {
                        "type": 9,
                        "content": "80"
                    }
                ]
            },
            {
                "itemId": 721,
                "label": "弹力双绉12MM",
                "value": "弹力双绉12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力双绉12MM"
                    },
                    {
                        "type": 8,
                        "content": "69"
                    },
                    {
                        "type": 9,
                        "content": "69"
                    }
                ]
            },
            {
                "itemId": 722,
                "label": "弹力双绉14MM",
                "value": "弹力双绉14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力双绉14MM"
                    },
                    {
                        "type": 8,
                        "content": "78"
                    },
                    {
                        "type": 9,
                        "content": "78"
                    }
                ]
            },
            {
                "itemId": 723,
                "label": "弹力双绉16MM",
                "value": "弹力双绉16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力双绉16MM"
                    },
                    {
                        "type": 8,
                        "content": "86"
                    },
                    {
                        "type": 9,
                        "content": "86"
                    }
                ]
            }
        ],
        "label": "双绉",
        "value": "双绉"
    },
    {
        "children": [
            {
                "itemId": 726,
                "label": "双宫",
                "value": "双宫",
                "option": [
                    {
                        "type": 0,
                        "content": "双宫"
                    }
                ]
            },
            {
                "itemId": 727,
                "label": "弹力斜纹绸16MM",
                "value": "弹力斜纹绸16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力斜纹绸16MM"
                    }
                ]
            },
            {
                "itemId": 728,
                "label": "弹力斜纹绸19MM",
                "value": "弹力斜纹绸19MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力斜纹绸19MM"
                    }
                ]
            },
            {
                "itemId": 729,
                "label": "弹力电力纺",
                "value": "弹力电力纺",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力电力纺"
                    }
                ]
            },
            {
                "itemId": 730,
                "label": "斜纹绸10MM",
                "value": "斜纹绸10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "斜纹绸10MM"
                    }
                ]
            },
            {
                "itemId": 731,
                "label": "斜纹绸12MM",
                "value": "斜纹绸12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "斜纹绸12MM"
                    }
                ]
            },
            {
                "itemId": 732,
                "label": "斜纹绸14MM",
                "value": "斜纹绸14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "斜纹绸14MM"
                    }
                ]
            },
            {
                "itemId": 733,
                "label": "斜纹绸16MM",
                "value": "斜纹绸16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "斜纹绸16MM"
                    }
                ]
            },
            {
                "itemId": 734,
                "label": "斜纹绸18MM",
                "value": "斜纹绸18MM",
                "option": [
                    {
                        "type": 0,
                        "content": "斜纹绸18MM"
                    }
                ]
            },
            {
                "itemId": 735,
                "label": "电力纺",
                "value": "电力纺",
                "option": [
                    {
                        "type": 0,
                        "content": "电力纺"
                    }
                ]
            }
        ],
        "label": "斜纹绸",
        "value": "斜纹绸"
    },
    {
        "children": [
            {
                "itemId": 736,
                "label": "欧根纱10MM",
                "value": "欧根纱10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "欧根纱10MM"
                    }
                ]
            },
            {
                "itemId": 737,
                "label": "欧根纱5.5MM",
                "value": "欧根纱5.5MM",
                "option": [
                    {
                        "type": 0,
                        "content": "欧根纱5.5MM"
                    }
                ]
            },
            {
                "itemId": 738,
                "label": "欧根纱8MM",
                "value": "欧根纱8MM",
                "option": [
                    {
                        "type": 0,
                        "content": "欧根纱8MM"
                    }
                ]
            },
            {
                "itemId": 739,
                "label": "欧根缎",
                "value": "欧根缎",
                "option": [
                    {
                        "type": 0,
                        "content": "欧根缎"
                    }
                ]
            }
        ],
        "label": "欧根纱",
        "value": "欧根纱"
    },
    {
        "children": [
            {
                "itemId": 740,
                "label": "丝人丝桑波缎",
                "value": "丝人丝桑波缎",
                "option": [
                    {
                        "type": 0,
                        "content": "丝人丝桑波缎"
                    }
                ]
            },
            {
                "itemId": 741,
                "label": "弹力桑波缎",
                "value": "弹力桑波缎",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力桑波缎"
                    }
                ]
            },
            {
                "itemId": 742,
                "label": "弹力素绉缎12MM",
                "value": "弹力素绉缎12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力素绉缎12MM"
                    }
                ]
            },
            {
                "itemId": 743,
                "label": "弹力素绉缎14MM",
                "value": "弹力素绉缎14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力素绉缎14MM"
                    }
                ]
            },
            {
                "itemId": 744,
                "label": "弹力素绉缎16MM",
                "value": "弹力素绉缎16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力素绉缎16MM"
                    }
                ]
            },
            {
                "itemId": 745,
                "label": "弹力素绉缎19MM",
                "value": "弹力素绉缎19MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力素绉缎19MM"
                    }
                ]
            },
            {
                "itemId": 746,
                "label": "弹力素绉缎22MM",
                "value": "弹力素绉缎22MM",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力素绉缎22MM"
                    }
                ]
            },
            {
                "itemId": 747,
                "label": "桑波缎14MM",
                "value": "桑波缎14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "桑波缎14MM"
                    }
                ]
            },
            {
                "itemId": 748,
                "label": "桑波缎15MM",
                "value": "桑波缎15MM",
                "option": [
                    {
                        "type": 0,
                        "content": "桑波缎15MM"
                    }
                ]
            },
            {
                "itemId": 749,
                "label": "桑波缎16MM",
                "value": "桑波缎16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "桑波缎16MM"
                    }
                ]
            },
            {
                "itemId": 750,
                "label": "桑波缎17MM",
                "value": "桑波缎17MM",
                "option": [
                    {
                        "type": 0,
                        "content": "桑波缎17MM"
                    }
                ]
            },
            {
                "itemId": 751,
                "label": "素绉缎12MM",
                "value": "素绉缎12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "素绉缎12MM"
                    }
                ]
            },
            {
                "itemId": 752,
                "label": "素绉缎14MM",
                "value": "素绉缎14MM",
                "option": [
                    {
                        "type": 0,
                        "content": "素绉缎14MM"
                    }
                ]
            },
            {
                "itemId": 753,
                "label": "素绉缎16MM",
                "value": "素绉缎16MM",
                "option": [
                    {
                        "type": 0,
                        "content": "素绉缎16MM"
                    }
                ]
            },
            {
                "itemId": 754,
                "label": "素绉缎19MM",
                "value": "素绉缎19MM",
                "option": [
                    {
                        "type": 0,
                        "content": "素绉缎19MM"
                    }
                ]
            }
        ],
        "label": "素绉缎",
        "value": "素绉缎"
    },
    {
        "children": [
            {
                "itemId": 755,
                "label": "弹力雪纺",
                "value": "弹力雪纺",
                "option": [
                    {
                        "type": 0,
                        "content": "弹力雪纺"
                    }
                ]
            },
            {
                "itemId": 756,
                "label": "横条雪纺",
                "value": "横条雪纺",
                "option": [
                    {
                        "type": 0,
                        "content": "横条雪纺"
                    }
                ]
            },
            {
                "itemId": 757,
                "label": "雪纺10MM",
                "value": "雪纺10MM",
                "option": [
                    {
                        "type": 0,
                        "content": "雪纺10MM"
                    }
                ]
            },
            {
                "itemId": 758,
                "label": "雪纺12MM",
                "value": "雪纺12MM",
                "option": [
                    {
                        "type": 0,
                        "content": "雪纺12MM"
                    }
                ]
            },
            {
                "itemId": 759,
                "label": "雪纺6MM",
                "value": "雪纺6MM",
                "option": [
                    {
                        "type": 0,
                        "content": "雪纺6MM"
                    }
                ]
            },
            {
                "itemId": 760,
                "label": "雪纺8MM",
                "value": "雪纺8MM",
                "option": [
                    {
                        "type": 0,
                        "content": "雪纺8MM"
                    }
                ]
            }
        ],
        "label": "雪纺",
        "value": "雪纺"
    }
]

export const cateData2 = [
    {
        "children": [
            {
                "itemId": 685,
                "label": "乔其10MM",
                "value": "乔其10MM",
                "option": [
                    {
                        "type": 8,
                        "content": "54"
                    },
                    {
                        "type": 9,
                        "content": "54"
                    }
                ]
            },
            {
                "itemId": 686,
                "label": "乔其12MM",
                "value": "乔其12MM",
                "option": [
                    {
                        "type": 8,
                        "content": "62"
                    },
                    {
                        "type": 9,
                        "content": "62"
                    }
                ]
            },
            {
                "itemId": 689,
                "label": "乔其8MM",
                "value": "乔其8MM",
                "option": [
                    {
                        "type": 8,
                        "content": "43"
                    },
                    {
                        "type": 9,
                        "content": "43"
                    }
                ]
            }
        ],
        "label": "乔其",
        "value": "乔其"
    },
    {
        "children": [
            {
                "itemId": 710,
                "label": "丝人丝双绉",
                "value": "丝人丝双绉",
                "option": [
                    {
                        "type": 9,
                        "content": "55"
                    },
                    {
                        "type": 8,
                        "content": "55"
                    }
                ]
            },
            {
                "itemId": 715,
                "label": "双绉12MM",
                "value": "双绉12MM",
                "option": [
                    {
                        "type": 8,
                        "content": "63"
                    },
                    {
                        "type": 9,
                        "content": "63"
                    }
                ]
            },
            {
                "itemId": 716,
                "label": "双绉14MM",
                "value": "双绉14MM",
                "option": [
                    {
                        "type": 8,
                        "content": "71"
                    },
                    {
                        "type": 9,
                        "content": "71"
                    }
                ]
            },
            {
                "itemId": 717,
                "label": "双绉16MM",
                "value": "双绉16MM",
                "option": [
                    {
                        "type": 8,
                        "content": "80"
                    },
                    {
                        "type": 9,
                        "content": "80"
                    }
                ]
            },
            {
                "itemId": 721,
                "label": "弹力双绉12MM",
                "value": "弹力双绉12MM",
                "option": [
                    {
                        "type": 8,
                        "content": "69"
                    },
                    {
                        "type": 9,
                        "content": "69"
                    }
                ]
            },
            {
                "itemId": 722,
                "label": "弹力双绉14MM",
                "value": "弹力双绉14MM",
                "option": [
                    {
                        "type": 8,
                        "content": "78"
                    },
                    {
                        "type": 9,
                        "content": "78"
                    }
                ]
            },
            {
                "itemId": 723,
                "label": "弹力双绉16MM",
                "value": "弹力双绉16MM",
                "option": [
                    {
                        "type": 8,
                        "content": "86"
                    },
                    {
                        "type": 9,
                        "content": "86"
                    }
                ]
            }
        ],
        "label": "双绉",
        "value": "双绉"
    }
] 